export interface ErrorDisplayProps {
  header: string
  message: { message: string; classes?: string }[]
}

// Default error state for network or server issues
export const internalServerError: ErrorDisplayProps = {
  header: 'エラー: 通信に失敗しました。',
  message: [
    { message: '通信状況やサーバーの一時的な問題が原因の可能性があります。' },
    {
      message:
        '時間をおいて再度お試しいただくか、面接時に担当者へご連絡ください。',
    },
  ],
}

export const badRequestError: ErrorDisplayProps = {
  header: 'エラー: 本人確認ができませんでした。',
  message: [
    {
      message:
        'ご入力いただいた生年月日が登録情報と一致しませんでした。再度正しい生年月日を入力してください。',
    },
    { message: '問題が解決しない場合は、下記までお問い合わせください。' },
    { message: 'UTグループ採用窓口', classes: 'pb-0! mb-0!' },
    { message: 'TEL：0120-971-999', classes: 'mt-0! pt-0! text-start' },
  ],
}

export const notFoundError: ErrorDisplayProps = {
  header: 'エラー: サーバーにあなたのレコードが見つかりませんでした。',
  message: [{ message: '面談前アンケートのURLに誤りがある可能性があります。' }],
}
